import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../../../providers/AuthContext';
import Loader from '../Loader';
import { useNavigate } from 'react-router-dom';

const Profile = () => {
  const { user, token, loading, logout } = useContext(AuthContext);
  const [serverData, setServerData]      = useState(null);
  const [orders, setOrders]              = useState([]);
  const [loadingOrders, setLoadingOrders]= useState(true);
  const [err, setErr]                    = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) return;
    (async () => {
      try {
        const [profileRes, ordersRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/user/profile`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          }),
          fetch(`${process.env.REACT_APP_API_URL}/orders/user/my-orders`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          })
        ]);

        if (!profileRes.ok) throw new Error((await profileRes.json()).message);
        setServerData(await profileRes.json());

        if (ordersRes.ok) {
          const ordersData = await ordersRes.json();
          setOrders(ordersData);
        }
      } catch (e) {
        setErr(e.message);
      } finally {
        setLoadingOrders(false);
      }
    })();
  }, [token]);

  if (loading) {
    return <Loader />;
  }

  if (!user) {
    navigate('/user');
    return null;
  }

  return (
    <div className="container-fluid py-4 py-md-5" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div className="container" style={{ maxWidth: '900px' }}>
        {/* Header Card - Avatar y Info Principal */}
        <div 
          className="card shadow-sm mb-4" 
          style={{ 
            border: 'none',
            borderRadius: '16px',
            overflow: 'hidden'
          }}
        >
          <div 
            className="card-body text-center py-5"
            style={{
              background: 'linear-gradient(135deg, #000000 0%, #2d2d2d 100%)'
            }}
          >
            <div className="position-relative d-inline-block mb-3">
              {user.photoURL ? (
                <img
                  src={user.photoURL}
                  alt="Avatar"
                  className="rounded-circle"
                  style={{ 
                    width: '120px', 
                    height: '120px', 
                    objectFit: 'cover',
                    border: '4px solid var(--accent-success, #1a1a1a)',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                  }}
                  onError={e => { 
                    e.currentTarget.style.display = 'none';
                    e.currentTarget.nextElementSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className="rounded-circle"
                style={{
                  width: '120px',
                  height: '120px',
                  backgroundColor: 'var(--accent-success, #1a1a1a)',
                  color: 'white',
                  display: user.photoURL ? 'none' : 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '48px',
                  fontWeight: 'bold',
                  border: '4px solid var(--accent-success, #1a1a1a)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                }}
              >
                {user.displayName?.charAt(0)?.toUpperCase() || user.email?.charAt(0)?.toUpperCase() || 'U'}
              </div>
              {user.emailVerified && (
                <div 
                  className="position-absolute"
                  style={{
                    bottom: '0',
                    right: '0',
                    backgroundColor: 'var(--accent-success, #1a1a1a)',
                    borderRadius: '50%',
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '3px solid #1a1a1a',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
                  }}
                  title="Cuenta verificada"
                >
                  <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                  </svg>
                </div>
              )}
            </div>
            <h2 className="mb-2 text-white" style={{ fontWeight: '600' }}>
              {user.displayName}
            </h2>
            <p className="mb-0" style={{ color: 'var(--accent-hover, #c9a96e)', fontSize: '1rem' }}>
              {user.email}
            </p>
          </div>
        </div>

        {/* Información de Usuario */}
        <div 
          className="card shadow-sm mb-4" 
          style={{ 
            border: 'none',
            borderRadius: '16px'
          }}
        >
          <div className="card-body p-4">
            <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
              Información de la Cuenta
            </h5>
            <div className="row g-4">
              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'var(--accent-success, #1a1a1a)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      UID
                    </h6>
                  </div>
                  <p className="mb-0 text-break" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.uid}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: user.emailVerified ? 'var(--accent-success, #1a1a1a)' : '#6c757d',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Verificado
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.emailVerified ? 'Sí' : 'No'}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'var(--accent-success, #1a1a1a)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Teléfono
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {user.phoneNumber || '–'}
                  </p>
                </div>
              </div>

              <div className="col-12 col-sm-6 col-lg-3">
                <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                  <div className="d-flex align-items-center mb-2">
                    <div 
                      className="rounded-circle me-2"
                      style={{
                        width: '32px',
                        height: '32px',
                        backgroundColor: 'var(--accent-success, #1a1a1a)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                    >
                      <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                        <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"/>
                      </svg>
                    </div>
                    <h6 className="mb-0" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Miembro desde
                    </h6>
                  </div>
                  <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                    {new Date(user.metadata.creationTime).toLocaleDateString()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Historial de Pedidos */}
        <div 
          className="card shadow-sm mb-4" 
          style={{ 
            border: 'none',
            borderRadius: '16px'
          }}
        >
          <div className="card-body p-4">
            <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
              Historial de Pedidos
            </h5>
            
            {loadingOrders ? (
              <div className="text-center py-4">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Cargando pedidos...</span>
                </div>
              </div>
            ) : orders.length === 0 ? (
              <div className="text-center py-4">
                <i className="fa-solid fa-box-open mb-3" style={{ fontSize: '3rem', color: '#ccc' }}></i>
                <p className="text-muted mb-0">No tienes pedidos anteriores.</p>
                <button 
                  className="btn mt-3"
                  style={{ backgroundColor: 'var(--accent-success, #1a1a1a)', color: 'white', borderRadius: '8px' }}
                  onClick={() => navigate('/tienda')}
                >
                  Ir a la tienda
                </button>
              </div>
            ) : (
              <div className="table-responsive">
                <table className="table align-middle">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th scope="col" className="py-3" style={{ borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', color: '#6c757d', fontWeight: '500' }}>Pedido</th>
                      <th scope="col" className="py-3" style={{ color: '#6c757d', fontWeight: '500' }}>Fecha</th>
                      <th scope="col" className="py-3" style={{ color: '#6c757d', fontWeight: '500' }}>Total</th>
                      <th scope="col" className="py-3" style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', color: '#6c757d', fontWeight: '500' }}>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orders.map((order) => {
                      const getStatusColor = (status) => {
                        switch (status) {
                          case 'en espera': return { bg: '#fff3cd', text: '#856404' };
                          case 'en preparacion': return { bg: '#cce5ff', text: '#004085' };
                          case 'terminado': 
                          case 'enviado': return { bg: '#d1ecf1', text: '#0c5460' };
                          case 'entregado': return { bg: '#d4edda', text: '#155724' };
                          case 'cancelado': return { bg: '#f8d7da', text: '#721c24' };
                          default: return { bg: '#e2e3e5', text: '#383d41' };
                        }
                      };
                      const statusColor = getStatusColor(order.status);

                      return (
                        <tr key={order._id}>
                          <td className="py-3">
                            <span style={{ fontWeight: '500', color: '#1a1a1a' }}>#{order.orderNumber}</span>
                          </td>
                          <td className="py-3">
                            {new Date(order.date).toLocaleDateString()}
                          </td>
                          <td className="py-3">
                            ${order.total}
                          </td>
                          <td className="py-3">
                            <span 
                              className="badge rounded-pill" 
                              style={{ 
                                backgroundColor: statusColor.bg, 
                                color: statusColor.text,
                                fontSize: '0.85rem',
                                padding: '0.4em 0.8em',
                                fontWeight: '500'
                              }}
                            >
                              {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>

        {/* Datos del Servidor */}
        {serverData && (
          <div 
            className="card shadow-sm mb-4" 
            style={{ 
              border: 'none',
              borderRadius: '16px'
            }}
          >
            <div className="card-body p-4">
              <h5 className="mb-4" style={{ fontWeight: '600', color: '#1a1a1a' }}>
                Datos desde Servidor
              </h5>
              <div className="row g-4">
                <div className="col-12 col-md-6">
                  <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <h6 className="mb-2" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      UID Servidor
                    </h6>
                    <p className="mb-0 text-break" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                      {serverData.uid}
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                    <h6 className="mb-2" style={{ fontSize: '0.875rem', color: '#6c757d' }}>
                      Nombre Servidor
                    </h6>
                    <p className="mb-0" style={{ fontSize: '0.875rem', fontWeight: '500', color: '#1a1a1a' }}>
                      {serverData.displayName}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Error Alert */}
        {err && (
          <div 
            className="alert alert-danger mb-4" 
            style={{ 
              borderRadius: '12px',
              border: 'none'
            }}
          >
            <strong>Error:</strong> {err}
          </div>
        )}

        {/* Botón Cerrar Sesión */}
        <div className="text-center">
          <button
            className="btn btn-lg px-5"
            onClick={() => logout()}
            style={{
              backgroundColor: '#1a1a1a',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontWeight: '500',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--accent-hover, #c9a96e)';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--brand-primary, #1a1a1a)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
            }}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
